import { useMemo } from "react";
import { useNavigate } from "react-router";

import { ArrowRight, External } from "components/icons/generated";
import useMainNavigationAllItems from "components/MainNavigation/hooks/useAllMenuItems";

import { CommandPaletteActionType, CommandPaletteBucket } from "../types";
import { BUCKET_IDS } from "../constants";

const useCommandPaletteNavigationBucket = (): CommandPaletteBucket => {
  const navigate = useNavigate();

  const { allMenuItems } = useMainNavigationAllItems();

  const navigationItems = useMemo(
    () =>
      allMenuItems.map((item) => ({
        type: CommandPaletteActionType.SIMPLE,
        id: `go-to-${item.id}`,
        title: item.title,
        keywords: ["navigate", "go to"],
        bucketId: BUCKET_IDS.NAVIGATION,
        icon: item.href ? External : ArrowRight,
        onAction: () => {
          if (item.to) {
            navigate(item.to);
          }
          if (item.href) {
            window.open(item.href, "_blank");
          }
          if (item.onAction) {
            item.onAction();
          }
        },
      })),
    [allMenuItems, navigate]
  );

  return useMemo(
    () => ({
      id: BUCKET_IDS.NAVIGATION,
      title: "Navigation",
      order: 2,
      getActions: () => navigationItems,
    }),
    [navigationItems]
  );
};

export default useCommandPaletteNavigationBucket;
